var map = {
	"./flat-roof.png": "0b3f",
	"./home-graphic-en-BE-mobile.png": "43a2",
	"./home-graphic-en-BE.png": "7695",
	"./home-graphic-fr-BE-mobile.png": "241a",
	"./home-graphic-fr-BE.png": "21d4",
	"./home-graphic-nl-BE-mobile.png": "7bc6",
	"./home-graphic-nl-BE.png": "4f7f",
	"./mixed-roof.png": "0087",
	"./pitched-roof.png": "2c11",
	"./report-cover.png": "7b50",
	"./report-header.png": "090e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "278f";